// Client-only build-freshness check. `__BUILD_ID__` is baked into the bundle at
// build time (the build the user is running); `/version.json` is served
// uncached and reflects whatever build is currently deployed. When they differ,
// a newer build is live and this tab should offer a reload before it hits a
// stale chunk. See vite.config.ts (define + version.json plugin) and netlify.toml.

/** Where the running build polls to learn the currently-deployed build id. */
export const VERSION_URL = '/version.json';

/** How often to re-check for a newer build while the tab is open. */
export const VERSION_POLL_INTERVAL_MS = 5 * 60 * 1000;

/** Shape of build/client/version.json. */
export interface VersionManifest {
	buildId: string;
}

/**
 * Is a newer build live? Pure so it's unit-testable. True only when we have a
 * real fetched id that differs from the running build's baked id. A missing or
 * empty fetched id (offline, bad deploy, older build without the file) yields
 * false — we never nag on ambiguous input.
 */
export function isUpdateAvailable(
	currentBuildId: string,
	fetchedBuildId: string | null | undefined,
): boolean {
	if (!fetchedBuildId || !currentBuildId) {
		return false;
	}
	return fetchedBuildId !== currentBuildId;
}
